export enum HttpHeader {
  Accept = 'Accept',
  Authorization = 'Authorization',
  ContentType = 'Content-Type',
}
